import { type CurrencyType } from 'src/types/currency';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';

export const getPriceSplitOf = (
  price: number,
  currency: CurrencyType,
  splitCount = 4
) => getFormattedAmount(price / splitCount, currency);
